import { Factory } from "@/data/dao/Factory";
import { BookingDao } from "@/data/dao/service/BookingDao";
import type { IShift } from "@/data/model/Booking";
import { Weekday } from "@/data/model/Enums";
import { DateTime } from "@/data/util/DateTime";

import { i18n } from "@/portal/Trans";
import { DataTable, type IDataTableConfig } from "@/portal/elements/DataTable";
import { TableFilter } from "@/portal/elements/TableFilter";
import { portalEvents } from "@/portal/events/portalEvents";

export class ShiftTableController {
    private $element: JQuery;
    private dao: BookingDao;
    private dataTable: DataTable<IShift>;
    private search: TableFilter;

    constructor(element: JQuery) {
        this.$element = element;

        this.dao = Factory.getInstance<BookingDao>(BookingDao);

        const tableConfig: IDataTableConfig<IShift> = {
            columnMapping: [
                {
                    name: "Name",
                    property: "name",
                },
                {
                    name: "Zeitraum",
                    property: "dateFrom",
                    styles: { width: "20%" },
                    formatter: (m) => {
                        if (m.dateFrom === undefined && m.dateUntil === undefined) return "Immer";

                        if (m.dateFrom !== undefined && m.dateUntil === undefined)
                            return "ab " + DateTime.toDateString(m.dateFrom);

                        if (m.dateUntil !== undefined && m.dateFrom === undefined)
                            return "bis " + DateTime.toDateString(m.dateUntil);

                        return DateTime.toDateString(m.dateFrom!) + " bis " + DateTime.toDateString(m.dateUntil!);
                    },
                },
                {
                    name: "Wochentage",
                    property: "weekdays",
                    styles: { width: "20%" },
                    formatter: (m, p) => {
                        let str = "";
                        for (const i in p) str += i18n("enums.ShortWeekDay." + Weekday[p[i]]) + ", ";

                        if (str.length > 2) str = str.substr(0, str.length - 2);

                        return str;
                    },
                },
                {
                    name: "Uhrzeit",
                    property: "timeFrom",
                    styles: { width: "20%" },
                    formatter: (m) => {
                        if (m.timeFrom === undefined && m.timeUntil === undefined) return "Immer";

                        if (m.timeFrom !== undefined && m.timeUntil === undefined)
                            return "ab " + DateTime.timeSpanTotime(m.timeFrom);

                        if (m.timeUntil !== undefined && m.timeFrom === undefined)
                            return "bis " + DateTime.timeSpanTotime(m.timeUntil);

                        return DateTime.timeSpanTotime(m.timeFrom!) + " bis " + DateTime.timeSpanTotime(m.timeUntil!);
                    },
                },
                {
                    name: "",
                    property: "id",
                    styles: { width: "110px", "text-align": "right" },
                    formatter: () => {
                        return $(
                            '<span><a class="btn btn-sm btn-clean btn-icon btn-icon-md"><i class="la la-edit"></i></a></span>'
                        );
                    },
                },
            ],
            filterProvider: {
                getFilter: () => this.search.getValue(),
                setFilter: (d) => this.search.setValue(d),
            },
            defaultSortAsc: true,
            locationDependend: true,
            defaultSortProperty: "timeFrom",
        };

        this.search = new TableFilter().appendTo(this.$element.find("> .kt-portlet__body.tablefilter"));
        this.dataTable = new DataTable<IShift>(
            this.$element.find("> .kt-portlet__body > .kt-datatable"),
            this.dao.shiftDataSource,
            tableConfig
        );
        this.dataTable.onClick(
            (m) => {
                location.href = "/booking/shift/" + m.id;
            },
            (m) => {
                window.open("/booking/shift/" + m.id);
            }
        );

        this.dataTable.listenTo(this.search);
        portalEvents.OnLocationChanged.add(() => {
            this.dataTable.loadData(true);
        }, this);
    }
}
